<template>
  <div v-if="camera">
    <CameraSnapshotStatus :camera="camera" class="mb-4" />
    <div class="field">
      <label class="label">ID</label>
      <div class="control">
        <input class="input" type="text" v-model="camera.id" disabled />
      </div>
    </div>
    <div class="field">
      <label class="label">Name</label>
      <div class="control">
        <input class="input" type="text" v-model="camera.name" disabled />
      </div>
    </div>
    <div class="field">
      <label class="label">Project</label>
      <div class="control">
        <input
          class="input"
          type="text"
          v-model="camera.project.name"
          disabled
        />
      </div>
    </div>
    <div class="field">
      <label class="label">Project</label>
      <div class="control">
        <input
          class="input"
          type="text"
          v-model="camera.project.company.name"
          disabled
        />
      </div>
    </div>
    <div v-if="camera.version > 1" class="field">
      <label class="label">Last Snapshot Status</label>
      <div class="control">
        <p>{{ camera.last_snapshot_status }}</p>
      </div>
    </div>
    <div class="field">
      <label class="label">AWS Bucket</label>
      <div class="control">
        <input class="input" type="text" v-model="selectedCamera.aws_bucket" />
      </div>
    </div>
    <div class="field">
      <label class="label">AWS Folder</label>
      <div class="control">
        <input class="input" type="text" v-model="selectedCamera.aws_folder" />
      </div>
    </div>
    <div class="field">
      <label class="label">Latitude</label>
      <div class="control">
        <input class="input" type="number" step="any" v-model.number="selectedCamera.location.latitude" />
      </div>
    </div>
    <div class="field">
      <label class="label">Longitude</label>
      <div class="control">
        <input class="input" type="number" step="any" v-model.number="selectedCamera.location.longitude" />
      </div>
    </div>
    <div class="field">
      <label class="label">Heading</label>
      <div class="control">
        <input class="input" type="number" step="any" v-model.number="selectedCamera.heading" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CameraSnapshotStatus from "@/components/CameraSnapshotStatus.vue";
export default {
  name: "CameraGeneralTab",
  components: { CameraSnapshotStatus },
  props: {
    cameraData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["selectedCamera"]),
    camera() {
      return this.cameraData || this.selectedCamera;
    },
  },
  mounted() {},
};
</script>

<style></style>
